export const formsEs = {
  administrator: {
    title: {
      create: 'Crear Administrador',
      edit: 'Editar: ',
    },
    label: {
      name: 'Nombre',
      email: 'E-mail',
      password: 'Contraseña',
      repeatpassword: 'Repetir contraseña',
      phone: 'Teléfono',
      rol: 'Rol',
      bookmaker: 'Bookmaker',
    },
    buttons: {
      create: 'Crear',
      edit: 'Editar',
    }
  },
  competition: {
    title: {
      create: 'Crear Competición',
      edit: 'Editar: ',
    },
    label: {
      name: 'Nombre',
      country: 'País',
      countryCode: 'Codigo de país',
      provider: 'Proveedor',
      providerId: 'Id de proveedor',
      sport: 'Deporte',
      providerSeason: 'Temporada',
    },
    buttons: {
      create: 'Crear',
      edit: 'Editar',
    }
  },
  contest: {
    title: {
      create: 'Crear Campeonato',
      edit: 'Editar Campeonato: ',
    },
    form: {
      name: 'Nombre',
      competition: 'Competicion',
      matchset: 'Jornada',
      status: 'Estado',
      multiplier: 'Multiplicador',
      minpot: 'Bote garantizado',
      budget: 'Presupuesto',
      maxentries: 'Entradas máximas',
      entriesuser: 'Entradas por usuario',
      pooltype: 'Tipo de campeonato',
      payout: 'Distribución de premios',
      category: 'Categoría',
      format: 'Formato',
      network: 'Red',
      currency: 'Divisa',
      startdate: {
        date: 'Fecha de inicio',
        time: 'Hora de inicio'
      },
      enddate: {
        date: 'Fecha de fin',
        time: 'Hora de fin'
      },
      dateInfo: 'Las fechas sólo se pueden editar si el contest se encuentra en "pending", "new", "open".',
    },
    buttons: {
      create: 'Crear',
      edit: 'Editar',
    }
  },
  game: {
    title: {
      create: 'Crear juego',
      edit: 'Editar: ',
    },
    label: {
      name: 'Nombre',
      alias: 'Alias',
      provider: 'Proveedor',
      type: 'Tipo',
      image:'Imagen',
      license: 'Licencias',
      jurisdictions: 'Jurisdicciones',
      launchdate: 'Fecha de lanzamiento',
      teoricRTP: 'RTP Teórico',
      freespins: 'Admite Freespins',
      fun: 'Fun',
      volatility: 'Volatilidad',
      jackpot: 'Jackpot',
      bet: {
        title: 'Apuestas',
        default: 'Default',
        min: 'Min',
        max: 'Max',
        highest: 'Highest',
        mwm: 'Max win multiplier',
      },
      extrafields: 'Parámetros de configuración',
    },
    multicreate:{
      title:'Carga masiva de juegos',
      fileInput:'Selecciona un fichero',
      helpText:'Por favor, selecciona un proveedor y sube el archivo csv con la lista de juegos para la carga masiva.',
      loadedGamesText:'Se insertarán un total de',
      game:'juegos'
    },
    confirmationDialog: {
      status: {
        title: 'Confirmar',
        description: '¿Estás seguro de realizar la carga masiva de juegos?.',
        okText: 'Confirmar',
        cancelText: 'Cancelar',
      },
    },
    buttons: {
      create: 'Crear',
      edit: 'Editar',
    }
  },
  matchsets: {
    title: {
      create: 'Crear Jornada',
      edit: 'Editar Jornada: ',
    },
    steps: {
      step1: 'Selecciona tipo de jornada',
      step2: 'Crear Jornada',
      step3: 'Resumen'
    },
    match: 'Crear partido',
    rounds: 'Crear ronda',
    day: 'Crear día',
    form: {
      matchsetType: 'Tipo de jornada',
      name: 'Nombre',
      matches: 'Partidos',
      matchesInfo: 'Se necesita seleccionar una competición para seleccionar un partido',
      competition: 'Competiciones',
      matchday: 'Match day',
      date: 'Fecha',
      dateInfo: 'Todos los campos sólo se pueden editar si la jornada se encuentra en "pending" o "new".',
      startdate: {
        date: 'Fecha de inicio',
        time: 'Hora de inicio'
      },
      enddate: {
        date: 'Fecha de fin',
        time: 'Hora de fin'
      },
    },
    resume: 'Resumen',
    buttons: {
      next: 'Continuar',
      cancel: 'Cancelar',
      create: 'Crear',
      edit: 'Editar',
    }
  },
  network: {
    title: {
      create: 'Crear Red',
      edit: 'Editar: ',
    },
    memberInfo: 'Sólo es posible añadir miembros.',
    steps: {
      step1: 'Seleccionar Jurisdicción',
      step2: 'Crear Red',
      step3: 'Resume'
    },
    label: {
      name: 'Nombre',
      fee: 'Comisión',
      organizer: 'Organizador',
      members: 'Miembros',
      jurisdiction: 'Jurisdiccion',
    },
    buttons: {
      create: 'Crear',
      edit: 'Editar',
      next: 'Siguiente',
      update: 'Actualizar'
    }
  },
  operator: {
    title: {
      create: 'Crear Operador',
      edit: 'Editar: ',
    },
    label: {
      name: 'Nombre',
      id: 'Código',
      fantasyenabled: 'Enabled',
      competition: 'Competición',
      connector: 'Conector',
      connectorId: 'Id Conector',
      connectorKey: 'Clave Conector',
      key: 'Clave',
      casinoApi: 'CasinoApi',
      sportsApi: 'SportsApi',
      bonusApi: 'BonusApi',
      lobbyURL: 'URL del Lobby',
      cashier: 'URL de Cashier',
      virtualsports: 'URL de Virtualsports',
      sportsbook: 'URL de Sportsbook',
      jurisdiction: 'Jurisdicción',
      accountManager: 'Account Manager',
      invoice: {
        name: 'Nombre',
        address: 'Dirección',
        vat: 'VAT number',
        tax: 'Tax',
        phone: 'Teléfono',
        email: 'Email',
      },
      config: {
        title: 'Configuración',
        cl: 'Competition Labs',
        oi: 'Opt-In',
        retail: 'Retail',
        raf: 'Refer a friend',
        rafpercen: 'Porcentaje',
      },
      sms: {
        title: 'SMS',
        origin: 'Origen',
        enabled: 'Habilitado',
        user: 'Usuario',
        password: 'Contraseña',
      },
      extrafields: 'Campos adicionales',
    },
    buttons: {
      create: 'Crear',
      edit: 'Editar',
    }
  },
  provider: {
    title: {
      create: 'Crear Proveedor',
      edit: 'Editar: ',
    },
    label: {
      name: 'Nombre',
      code: 'Código',
      accountManager: 'Account Manager',
      fun: 'Fun',
      real: 'Real',
      mobile: 'Mobile',
      desktop: 'Desktop',
      urls: {
        launcher: 'Launcher',
        bonusAward: 'BonusAward',
        bonusCancel: 'BonusCancel',
        ping: 'Ping',
        roundDetails: 'RoundDetails',
        fixedLauncher: 'FixedLauncher',
        baseUrl: 'BaseUrl',
        gameList: 'GameList',
      },
      ggr: 'GGR',
      icon:'Icono',
      image:'Imagen',
      invoice: {
        name: 'Nombre',
        address: 'Dirección',
        vat: 'VAT number',
        tax: 'Tax',
        phone: 'Teléfono',
        email: 'Email',
      },
      config: {
        title: 'Configuración',
        rst: 'Devolver misma transacción',
        amb: 'Permitir múltiples apuestas',
        rnc: 'No cerrar Rollback',
        anr: 'Permitir ganancias sin ronda',
        aoc: 'Permitir ganancias en rondas cerradas',
        hfr: 'Have free rounds',
      },
      selection: 'Selección',
      singleGame: 'Mono Juego',
      multiGame: 'Multi Juego',
      singleUser: 'Mono Usuario',
      multiUser: 'Multi Usuario',
      customfields: 'Formulario Freerounds',
      extrafields: 'Parámetros de configuración',
      extrafieldsHidden: 'Parámetros de URL',
    },
    buttons:{
      create: 'Crear',
      edit: 'Editar',
    }
  },
  operatorProvider: {
    title: {
      operator: 'Operador: ',
      provider: ', Proveedor: ',
      create: ', Nuevo Proveedor',
      edit: 'Editar: ',
    },
    label: {
      provider: 'Proveedor',
      key1: 'Clave',
      key2: 'Clave secundaria',
      key3: 'Clave terciaria',
      ggr: 'GGR',
      cap: 'Bonus cap',
      urls: {
        launcher: 'Launcher',
        bonusAward: 'BonusAward',
        bonusCancel: 'BonusCancel',
        ping: 'Ping',
        roundDetails: 'RoundDetails',
        fixedLauncher: 'FixedLauncher',
        baseUrl: 'BaseUrl',
        gameList: 'GameList',
      },
      extrafields: 'Parámetros de configuración',
      extrafieldsHidden: 'Parámetros de URL',
      cl: {
        title: 'Competition Labs',
        f: 'feed',
        w: 'widget',
      },
    },
    button:{
      details: 'Ver detalles',
      openadd: 'Añadir nuevo proveedor',
      add: 'Añadir',
      edit: 'Editar',
    },
  },
  category: {
    title: {
      create: 'Crear Categoría',
      edit: 'Editar: ',
    },
    label: {
      name: 'Nombre',
      country: 'País',
      countryCode: 'Código de país',
      provider: 'Proveedor',
      futmondo: 'Futmondo',
      sport: 'Deporte',
      enabled: 'Activado',
    },
    table: {
      title: 'Añadir niveles',
      level: 'Nivel',
      name: 'Nombre',
      points: 'Puntos',
      rolldown: 'Roll Down',
      percentage: 'Porcentaje',
    },
    button:{
      create: 'Crear',
      edit: 'Editar',
    },
  },
  invoice:{
    title: {
      create: 'Crear factura',
    },
    provider: 'Proveedor',
    operator: 'Operador',
    customer: 'Cliente',
    selectClient: 'Selecciona cliente para la factura',
    nextButton: 'Siguiente',
    form: {
      invoiceID: 'Nº',
      invoiceDetails: 'Detalles de la factura',
      items: 'Conceptos',
      invoiceNotes: 'Notas de la factura',
      invoiceDate: 'Fecha factura',
      invoiceDue: 'Fecha pago',
      invoiceAmountDue: 'Cantidad Total',
      paymentDetails: 'Detalles de pago',
      paymentMethod: 'Método de pago: Transferencia Bancaria',
      paymentExpiration: 'Expiración: Efectivo',
      paymentAccountNumber: 'Nº de cuenta',
      paymentAdvice: 'Cobro revertido (-art.6.1.M) del R.D.1619/2012, 30 de Noviembre',
      generateInvoice: 'Generar factura',
      viewInvoiceTitle: 'Detalle de la factura',
      invoice: 'Factura',
      downloadInvoice: 'Descargar factura',
      discount: 'Descuento',
      tax: 'Impuestos',
    },
    label: {
      no: 'No.',
      description: 'Descripción',
      qty: 'Qty',
      price: 'Precio',
      discount: 'Descuento %',
      tax: 'Tax %',
      total: 'Total',
    },
  },
  freespins: {
    title: {
      create: 'Crear Freespins',
      edit: 'Editar: ',
    },
    steps: {
      title1: 'Paso 1',
      title2: 'Paso 2, Tipo y juegos',
      title3: 'Paso 3, Usuarios',
    },
    label: {
      name: 'Nombre',
      id: 'Identificación',
      daterange: 'Fechas',
      type: 'Tipo',
      rounds: 'Rounds',
      games: 'Juegos',
      operator: 'Operador',
      users: 'Usuarios',
      selection: 'Selección',
      manual: 'Manual',
      all: 'Todos',
    },
    button: {
      next: 'Siguiente',
      send: 'Enviar',
    },
  },
  lobby: {
    title: {
      create: 'Crear Lobby',
      edit: 'Editar: ',
    },
    label: {
      operator: 'Operador',
      providers: 'Proveedores',
      banner: {
        bannersTitle: 'Banner',
        title: 'Título',
        description: 'Descripción',
        imageDesktop: 'Imagen Escritorio',
        imageMobile: 'Imagen Móvil',
        url: 'URL',
      },
      new: 'Nueva',
      category: 'Categoría',
      name: 'Nombre',
      names: 'Nombre',
      nameslabel: 'Nombre',
      icon: 'Icono',
      img: 'Imagen',
      games: 'Juegos',
      gamesimg: 'Imagen',
      extra: {
        isNew: 'IsNew',
        featured: 'Featured',
        hot: 'Hot',
      },
    },
    button:{
      create: 'Crear',
      edit: 'Editar',
      addCategory: 'Añadir nueva categoría',
      addBanner: 'Añadir nuevo banner',
    },
  },
  freerounds: {
    title: {
      create: 'Crear Campaña',
      edit: 'Editar: ',
    },
    label: {
      externalId: 'External Id',
      daterange: 'Fechas',
      amount: 'Cantidad',
      games: 'Juegos',
      operator: 'Operador',
      provider: 'Proveedor',
      users: 'Usuarios',
      extrafields: 'Parámetros de configuración',
      extrafieldsHidden: 'Parámetros de URL',
      selection: 'Selección',
      manual: 'Manual',
      all: 'Todos',
    },
    button: {
      send: 'Enviar',
    },
  },
  providerIpList: {
    title: {
      main: 'IP\'s del proveedor',
      add:'Añadir nueva IP',
    },
    empty: 'No se han añadido Ips',
    button: {
      create: 'Crear',
    }
  },
  operatorIpList: {
    title: {
      main: 'IP\'s del operador',
      add:'Añadir nueva IP',
    },
    empty: 'No se han añadido Ips',
    button: {
      create: 'Crear',
    }
  },
};
